export default "__VITE_ASSET__BOkIcGsL__"